import * as React from 'react';
import { useTranslation } from 'next-i18next';
import LayoutOverlay from 'ap-admin-components/lib/Components/LayoutOverlay';
import Block from 'ap-admin-components/lib/Components/Block';
import Buttons from 'ap-admin-components/lib/Components/Buttons';
import Button from 'ap-admin-components/lib/Components/Button';
import Overlay from 'ap-admin-components/lib/Components/Overlay';
import useOverlayActions from '@/lib/hooks/useOverlayActions';
import { OverlayType } from '@/lib/enums/OverlayType.enum';
import { getOverlayNameWithKey } from '@/lib/helpers/overlay';

const key = OverlayType.file_update_confirm;

interface IProps {
  file: File | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const OverlayFileUpdateConfirm: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { isOpen, closeAll } = useOverlayActions();

  const onConfirm = () => props.onConfirm();

  const onCancel = () => {
    closeAll();
    props.onCancel();
  };

  return (
    <Overlay
      layout="dialog"
      isOpen={props.file ? isOpen(getOverlayNameWithKey(key, props.file.name)) : false}
      zIndex={200}
      doClose={onCancel}
      onClosed={onCancel}
    >
      <LayoutOverlay
        title={t('upload.existing.prompt')}
        scrollableContent={true}
        size="small"
      >
        <Block>
          <Buttons>
            <Button
              title={t('common.continue')}
              intent="primary"
              onClick={onConfirm}
            />
            <Button
              title={t('common.cancel')}
              intent="discrete"
              onClick={onCancel}
            />
          </Buttons>
        </Block>
      </LayoutOverlay>
    </Overlay>
  );
};

export default OverlayFileUpdateConfirm;
